import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Ota WhatsApp-ilmoitukset käyttöön',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Automaattiset puhelut odottavista tilauksista',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Aukioloajat',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Sijainti',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Ravintolan identiteetti',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Noutoaika',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Toimitusaika',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Henkilökunnan kirjautumistiedot',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Tuo valikko',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Suosikit',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Loppuunmyydyt tuotteet',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Alennuskoodit',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galleria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Lisää ravintolan logo ja pääväri',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Tilauslehtiset',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Luo Storefront',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Ota live-tilaukset käyttöön',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Ota Google Business käyttöön',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Tarkista, onko omistajalla/yhteyshenkilöllä WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Tarkista, että ravintolan numero on oikein automaattisia puheluita varten, jottei tilauksia jää huomaamatta',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Aseta ravintolan aukioloajat',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Aseta ravintolan sijainti',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Aseta Storefrontissa näkyvä ravintolatyyppi ja keittiöt',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Määritä noutoaika-asetukset',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Määritä toimitusaika-asetukset',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Määritä henkilökunnan tunnukset',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Tuo ruokalista kolmannen osapuolen palveluntarjoajalta',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Merkitse 4 tuotetta suosikeiksi. Kysy ravintolalta, mitkä ovat 4 suosituinta ruokaa',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Määritä loppuunmyytyjen tuotteiden toiminta',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Määritä alennuskoodit',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Päivitä galleria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Hae logo ravintolalta tai Lieferandon ravintolasivulta ja tallenna se sieltä. Valitse väri, joka on eniten esillä ravintolan logossa',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Muokkaa lehtisen ulkoasua ja luo tilaus',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Luo Storefront ja muokkaa sivustoa tarvittaessa',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Ota live-tilaukset käyttöön (”vain lanseerauspäivänä!”)',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Yhdistä Google Business -tili',
  },
  buttons: {
    mark_as_complete: 'Merkitse valmiiksi',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
  },
};
